import type { Grant } from "@/views/grant/grant";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};

function addAuthRequestFields(entity: Grant) {
  entity._authRequestFields = ["id", "statusMurn"];
  return entity;
}
function getInitialData() {
  const result = {} as Grant; //TODO: ts
  return addAuthRequestFields(result);
}
async function skinnyResponseAdapter(response: { data: Grant }) {
  addAuthRequestFields(response.data);
  return response.data;
}
async function responseAdapter(response: { data: Grant }) {
  return await skinnyResponseAdapter(response);
}
function requestAdapter(data: Grant) {
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Grant) {}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: Grant) {}
